export const GET_MRI_DOCUMENT = 'GET_MRI_DOCUMENT'
export const MRI_DOC_LOADING = 'MRI_DOC_LOADING'
export const CLEAR_MRI = 'CLEAR_MRI'
export const RESET_MRI_MODAL = 'RESET_MRI_MODAL'
